import { FC, useState } from "react";
import Switch from "react-switch";
import classNames from "classnames";
import { ISwitchCarmaProps } from "./types";
import styles from "./Switch.module.css";

const SwitchCarma: FC<ISwitchCarmaProps> = ({ isChecked, onChange, className, isToggle = true }) => {
  const [isCheckedState, setIsCheckedState] = useState(isChecked);

  const handleChange = (checked: boolean) => {
    setIsCheckedState(checked);
    onChange(checked);
  }

  return (
    <Switch
      handleDiameter={24}
      height={32}
      width={56}
      uncheckedIcon={false}
      checkedIcon={false}
      className={classNames(
        styles["switch"], 
        isCheckedState && isToggle && styles["is-active"], 
        className, 
        !isToggle && styles["is-toggle"])}
      onChange={handleChange}
      checked={isCheckedState} />
  );
}

export default SwitchCarma;
